<template>
  <div class="news-owner clearfix">
    <companyTitle></companyTitle>
    <b-button
      class="mr-3 mt-3 float-right"
      type="button"
      variant="primary"
      @click="$router.push({ name: 'oneNews-create' })"
      >新增</b-button
    >
    <b-pagination-nav
      :link-gen="linkGen"
      :number-of-pages="$store.getters.paginationInNewsOwner.last_page"
      @change="$store.dispatch('fetchNewsOwner', $event)"
      use-router
      class="mt-3"
    ></b-pagination-nav>
    <tableList
      :isSelectable="true"
      :fields="fields"
      :items="$store.getters.newsOwnerList"
      :sort-by.sync="sortBy"
      @click="openModal($event)"
      @toDetail="toDetail"
    >
    </tableList>
    <tableListNoData
      v-if="$store.getters.newsOwnerList.length === 0"
    ></tableListNoData>

    <!-- modal -->
    <b-modal ref="double-check-delete-newsOwner">
      <p class="text-center">是否刪除？</p>
      <template v-slot:modal-footer>
        <div class="text-center">
          <b-button @click="submit" class="mr-3" type="button" variant="primary"
            >確定</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import tableList from "@/components/TableList.vue";
import tableListNoData from "@/components/TableListNoData.vue";
import companyTitle from "@/components/CompanyTitle.vue";
export default {
  components: {
    tableList,
    tableListNoData,
    companyTitle
  },
  computed: {
    sortBy() {
      return "";
    },
    fields() {
      return [
        { key: "released_at", label: "發布日期", sortable: true },
        { key: "title", label: "標題", sortable: true },
        { key: "user", label: "轉貼者", sortable: true }
      ];
    }
  },
  data() {
    return {
      deleteData: {
        news_ids: []
      }
    };
  },
  methods: {
    openModal(selectedList) {
      this.$refs["double-check-delete-newsOwner"].show();
      this.setDeleteData(selectedList);
    },
    setDeleteData(selectedList) {
      this.deleteData.news_ids = selectedList.map(item => item.id);
    },
    submit() {
      this.$store.dispatch("deleteOneNews", this.deleteData).then(() => {
        this.$refs["double-check-delete-newsOwner"].hide();
        const page = 1;
        this.$store.dispatch("fetchNewsOwner", page);
      });
    },
    toDetail(oneNews) {
      this.$router.push({
        name: "oneNews-edit",
        params: { oneNewsId: oneNews.id }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
